import { Stack, StackProps, styled } from "@mui/material";

export interface SectionProps extends StackProps {
  edge?: "start" | "end";
  pad?: "start" | "end" | "both";
}

export const Section = styled(Stack, {
  shouldForwardProp: (name) => name !== "pad" && name !== "edge",
})<SectionProps>(({ edge, pad, theme }) => {
  const { breakpoints, spacing } = theme;

  const padStart = pad === "both" || pad === "start";
  const padEnd = pad === "both" || pad === "end";
  const edgeStart = edge === "start";

  return {
    display: "flex",
    flexDirection: "column",
    paddingBottom: `calc(env(safe-area-inset-bottom) + ${spacing(padEnd ? 16 : 6)})`,
    paddingTop: `calc(env(safe-area-inset-top) + ${spacing(padStart ? 16 : edgeStart ? 10 : 6)})`,
    position: "relative",
    [breakpoints.up("sm")]: {
      paddingBottom: `calc(env(safe-area-inset-bottom) + ${spacing(padEnd ? 18 : 8)})`,
      paddingTop: `calc(env(safe-area-inset-top) + ${spacing(padStart ? 18 : edgeStart ? 10 : 8)})`,
    },
    [breakpoints.up("md")]: {
      paddingBottom: `calc(env(safe-area-inset-bottom) + ${spacing(padEnd ? 20 : 10)})`,
      paddingTop: `calc(env(safe-area-inset-top) + ${spacing(padStart ? 20 : edgeStart ? 10 : 10)})`,
    },
    [breakpoints.up("lg")]: {
      paddingBottom: `calc(env(safe-area-inset-bottom) + ${spacing(padEnd ? 22 : 12)})`,
      paddingTop: `calc(env(safe-area-inset-top) + ${spacing(padStart ? 22 : edgeStart ? 10 : 12)})`,
    },
  };
}) as React.FC<SectionProps>;
